import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Collapse, Card } from "react-bootstrap";
import { DatePicker } from "antd";
import moment from "moment";
import SimpleReactValidator from "simple-react-validator";
import scheduleMods from "data/schedule-mods";
import exceptions from "data/exceptions";
import sortObject from "functions/sort-object";
import SchedulingNewFiltersItem from "components/schedule/DraftsDetails/draft-filters-item";
import DraftFiltersServiceConfirmation from "components/schedule/DraftsDetails/draft-filters-service-confirmation";
import SelectExtended from "components/custom/forms/select-extended";
import {
    fetchAccountManagers,
    clearAccountManagers
} from "actions/employeeActions";

class SchedulingNewFilters extends React.PureComponent {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.handleFilter = this.handleFilter.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleSetDate = this.handleSetDate.bind(this);

        this.state = {
            isOpen: false,
        };

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => <div className="text-danger">{message}</div>
        });

        this.props.fetchAccountManagers();
    }

    componentWillUnmount() {
        this.props.clearAccountManagers();
    }

    handleSetDate = (name, value) => {
        const newState = {};

        newState[name] = value;
        this.setState(newState, () => {
            const dateString = value === null
                ? null
                : value.format(this.dateFormat);
            this.handleFilter(name, dateString);
        });
    };

    handleFilter(filterKey, value, isArray) {
        this.props.filterCallback(filterKey, value, isArray);
    }

    handleSearch () {
        this.props.onCheckCanSearch(this.props.activeFilters, () => {
            this.setState({
                isOpen: false
            });
            this.props.onSearch();
        });

        this.validator.showMessages();
        this.forceUpdate();
    }

    handleReset (callback = false) {
        this.props.onReset(callback);
    }

    render() {
        const {
            filters,
            activeFilters,
            titleFilteredCounts,
            accountManagers
        } = this.props;
        const { disableModeFilter, hideExceptionsFilter } = this.props;
        const submittedModeOption = [{
            label: scheduleMods.Submitted.title,
            value: scheduleMods.Submitted.value
        }];
        const modeOptions = Object.keys(scheduleMods).map(key => ({
            label: scheduleMods[key].title,
            value: scheduleMods[key].value
        }));

        const modeSelectOptions = disableModeFilter ? submittedModeOption : modeOptions;
        const accountManagersOptions = {};
        sortObject(
            accountManagers,
            Object.keys(accountManagers).map((value) => parseInt(value, 10)),
            "lastName",
            true
        ).forEach((index) => {
            accountManagersOptions[accountManagers[index].id] = accountManagers[index].name;
        });

        const {
            isOpen,
        } = this.state;

        const stores = {};
        if (filters.stores) {
            Object.keys(filters.stores).forEach(storeId => {
                stores[storeId] = `${filters.stores[storeId].storeNumber} - ${filters.stores[storeId].retailer}`;
            });
        }

        return (
            <div
                className="position-relative mb-4 z-100"
            >
                <Card className=" mb-2">
                    <Card.Header>
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="m-0">
                                {this.props.title}
                            </h4>
                            <div className="row">
                                <div className="text-success col-7 row" title="Filtered / Total">
                                    <span>{`Number of services: ${titleFilteredCounts.totalFilteredRecords}`}</span>
                                    <span>{`Total hours: ${filters.totalHours || 0}`}</span>
                                </div>

                                <Button
                                    onClick={() => this.setState({ isOpen: !isOpen })}
                                    aria-expanded={isOpen}
                                >
                                    {`${isOpen ? "Close" : "Expand"} Search`}
                                </Button>
                            </div>
                        </div>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <Collapse in={isOpen} className="col-12 p-3">
                            <div className="row">
                                <div className="col-9">
                                    <div className="row">
                                        <div className="col-3">
                                            <SchedulingNewFiltersItem
                                                label="Province"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("provinceIds", item)}
                                                filterObj={filters.provinces || {}}
                                                valuesObj={activeFilters.provinceIds || false}
                                            />
                                            <SchedulingNewFiltersItem
                                                label="City"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("cityIds", item, true)}
                                                filterObj={filters.cities || {}}
                                                valuesObj={activeFilters.cityIds || false}
                                            />
                                            <SchedulingNewFiltersItem
                                                label="Store#"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("storeIds", item)}
                                                filterObj={stores}
                                                valuesObj={activeFilters.storeIds || false}
                                            />
                                            <SchedulingNewFiltersItem
                                                label="Retailers"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("retailerIds", item)}
                                                filterObj={filters.retailers || {}}
                                                valuesObj={activeFilters.retailerIds || false}
                                            />
                                        </div>
                                        <div className="col-3">
                                            <SchedulingNewFiltersItem
                                                label="Jobs"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("jobIds", item)}
                                                filterObj={filters.jobs || {}}
                                                valuesObj={activeFilters.jobIds || false}
                                            />

                                            <SchedulingNewFiltersItem
                                                label="Merchandiser"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("merchandiserIds", item)}
                                                filterObj={filters.merchandisers || []}
                                                valuesObj={activeFilters.merchandiserIds || false}
                                            />
                                            <SchedulingNewFiltersItem
                                                label="Supervisor"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("supervisorIds", item)}
                                                filterObj={filters.supervisors || []}
                                                valuesObj={activeFilters.supervisorIds || false}
                                            />
                                            <DraftFiltersServiceConfirmation
                                                label="Service Confirmation"
                                                isMulti={true}
                                                onChange={item => this.handleFilter("serviceConfirmation", item)}
                                                filterObj={filters.serviceConfirmation || []}
                                                valuesObj={activeFilters.serviceConfirmation
                                                    || false}
                                            />
                                        </div>
                                        <div className="col-3">
                                            <SchedulingNewFiltersItem
                                                label="Trait"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("traits", item)}
                                                filterObj={filters.traits || []}
                                                valuesObj={activeFilters.traits || false}
                                            />
                                            <SchedulingNewFiltersItem
                                                label="Hours"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("hours", item)}
                                                filterObj={filters.hours || []}
                                                valuesObj={activeFilters.hours || false}
                                            />
                                            <div className="mb-1 draft-filter-wrapper form-group">
                                                <label className="d-block mb-0 font-weight-bold form-label">
                                                    Start Date
                                                </label>
                                                <DatePicker
                                                    value={activeFilters.earliestDate
                                                        ? moment(activeFilters.earliestDate)
                                                        : null
                                                    }
                                                    format={this.dateFormat}
                                                    onChange={date => {
                                                        this.handleSetDate("earliestDate", date);
                                                    }}
                                                    disabledDate={(current) => {
                                                        if (activeFilters.latestDate === null) {
                                                            return false;
                                                        }
                                                        // eslint-disable-next-line max-len
                                                        return current && current >= moment(activeFilters.latestDate).add(1, "days");
                                                    }}
                                                    className="d-block"
                                                    allowClear={true}
                                                />
                                                {activeFilters.mode && (
                                                    [
                                                        scheduleMods.Open.value,
                                                        scheduleMods.Saved.value
                                                    ].indexOf(activeFilters.mode.value) > -1
                                                )
                                                    ? this.validator.message("earliestDate", activeFilters.earliestDate, "required")
                                                    : null
                                                }
                                            </div>
                                            <div className="mb-1 draft-filter-wrapper form-group">
                                                <label className="d-block mb-0 font-weight-bold form-label">End Date</label>
                                                <DatePicker
                                                    value={activeFilters.latestDate
                                                        ? moment(activeFilters.latestDate)
                                                        : null
                                                    }
                                                    format={this.dateFormat}
                                                    onChange={date => {
                                                        this.handleSetDate("latestDate", date);
                                                    }}
                                                    disabledDate={(current) => {
                                                        if (activeFilters.earliestDate === null) {
                                                            return false;
                                                        }
                                                        // eslint-disable-next-line max-len
                                                        return current && current <= moment(activeFilters.earliestDate).subtract(1, "days");
                                                    }}
                                                    className="d-block"
                                                />
                                                {activeFilters.mode && (
                                                    [
                                                        scheduleMods.Open.value,
                                                        scheduleMods.Saved.value
                                                    ].indexOf(activeFilters.mode.value) > -1
                                                )
                                                    ? this.validator.message("latestDate", activeFilters.latestDate, "required")
                                                    : null
                                                }
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="mb-1 draft-filter-wrapper">
                                                <label className="mb-0 font-weight-bold">
                                                    Mode
                                                </label>
                                                <div className="d-block">
                                                    <SelectExtended
                                                        options={modeSelectOptions}
                                                        isLoading={false}
                                                        isClearable={false}
                                                        isSearchable={!disableModeFilter}
                                                        isMulti={false}
                                                        value={activeFilters.mode || modeSelectOptions[0]}
                                                        onChange={(item) => this.handleFilter("mode", item)}
                                                        className="filter-select"
                                                        classNamePrefix="filter-select"
                                                        isDisabled={disableModeFilter}
                                                    />
                                                </div>
                                            </div>
                                            {/*
                                            <SchedulingNewFiltersItem
                                                label="Mode"
                                                isMulti={false}
                                                isClearable={false}
                                                onChange={(item) => this.handleFilter("mode", item)}
                                                filterObj={modeOptions}
                                                valuesObj={activeFilters.mode || {
                                                    label: scheduleMods.NotActivated.title,
                                                    value: scheduleMods.NotActivated.value
                                                }}
                                            />
                                            */}
                                            <SchedulingNewFiltersItem
                                                label="Category"
                                                isMulti={false}
                                                onChange={(item) => this.handleFilter("category", item)}
                                                filterObj={{
                                                    All: "All",
                                                    Manual: "Manual",
                                                    Online: "Online"
                                                }}
                                                valuesObj={activeFilters.category || {
                                                    label: "All",
                                                    value: "All"
                                                }}
                                            />
                                            <SchedulingNewFiltersItem
                                                label="Account Manager"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("accountManagerIds", item)}
                                                filterObj={accountManagersOptions || {}}
                                                valuesObj={activeFilters.accountManagerIds || false}
                                            />
                                            {!hideExceptionsFilter && (
                                                <SchedulingNewFiltersItem
                                                    label="Exceptions"
                                                    isMulti={false}
                                                    onChange={(item) => this.handleFilter("exceptions", item)}
                                                    filterObj={exceptions}
                                                    valuesObj={activeFilters.exceptions || false}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-2 offset-1">
                                    <div className="h-100 d-flex flex-column justify-content-around">
                                        <Button
                                            variant="primary"
                                            onClick={this.handleSearch}
                                        >
                                            Search
                                        </Button>
                                        <Button
                                            variant="secondary"
                                            onClick={this.handleReset}
                                        >
                                            Reset
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

SchedulingNewFilters.defaultProps = {
    filters: {
        provinces: [],
        cities: [],
        stores: [],
        retailers: [],
        jobs: [],
        products: [],
        traits: [],
        hours: [],
        merchandisers: [],
        supervisors: [],
        earliestDate: null,
        latestDate: null,
    },
    disableModeFilter: false,
    hideExceptionsFilter: false
};

SchedulingNewFilters.propTypes = {
    filters: PropTypes.object.isRequired,
    filterCallback: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    titleFilteredCounts: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    accountManagers: state.employee.accountManagers,
    loading: state.globalFormErrors.loading
});

const mapStateToDispatch = dispatch => ({
    fetchAccountManagers: bindActionCreators(fetchAccountManagers, dispatch),
    clearAccountManagers: bindActionCreators(clearAccountManagers, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(SchedulingNewFilters);
